import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import UnderConstruction_zn from "../container/Blank/UnderConstruction_zn";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Venue = () => {
  return (
    <React.Fragment>
      <SEO title="活动会场 | ICSI 2022" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="活动会场"
        content="中文参会通道"
        contentTwo="活动会场"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <UnderConstruction_zn/>

        {/* <div className="entry-content">
          <p>&nbsp;</p>
          <h5>
          2022 国际群体智能大会 (ICSI) 的举办会场待公布。
          </h5>
          <p>&nbsp;</p>
          <h4>About the venue hotel</h4>
          Blue Horizon Hotel (Qingdao Shilaoren International Exhibition Center
          store) is affiliated to Shandong Blue Horizon Hotel Group, located in
          Laoshan District, Qingdao City, and shilao tourist resort in the
          south. It is an important part of Shandong International Conference
          and Exhibition Center. The rooms are distributed on the 3rd to 9th
          floors, with spacious and bright rooms, equipped with complete
          equipment such as broadband network, satellite TV, international
          direct dial telephone, small bar, electronic safe, etc., and equipped
          with transparent toilet and modern home facilities, showing luxury and
          fashion. It is an ideal choice for you to stay in business and life.
          <p>&nbsp;</p>
          <h4>About the university</h4>
          Ocean University of China (OUC) is a comprehensive university with
          particular strengths in oceanography and fisheries science. We have
          four campuses – Yushan, Fushan, Laoshan and Huangdao, which is
          currently under construction – all of which are united under our motto
          “Ocean embraces all streams; exploring promises reaching far.” OUC was
          one of the first universities approved to confer undergraduate and
          postgraduate degrees by the State Academic Degree Committee and it now
          offers courses in science, engineering, agronomy (fisheries),
          pharmaceutics, economics, management, liberal arts, law, education,
          history, and art. In 2017 it was included in China’s plan of building
          &quot;Double First-Rate&quot; universities, having previously also
          been on the list of &quot;Project 985&quot; universities (a list of
          China’s top 40 universities) and &quot;Project 211&quot; institutions
          (of China’s top 100 universities). It is now the recipient of
          significant national and provincial support and funding, which
          supports its bid to become a world class university.
          <p>&nbsp;</p>
          <h4>Location</h4>
          Address: No. 9-2, Miaoling Road, Laoshan District, Qingdao, China.
          Please refer to the{" "}
          <a href="https://goo.gl/maps/99Co7WDgMxujiNZM8">Google</a> or{" "}
          <a href="https://j.map.baidu.com/c5/tYK">Baidu</a> map to find the
          exact location of the conference venue.
          <p>&nbsp;</p>
          <div className="row">
            <iframe
              src="https://map.baidu.com/poi/%E9%9D%92%E5%B2%9B%E8%93%9D%E6%B5%B7%E5%A4%A7%E9%A5%AD%E5%BA%97(%E5%B4%82%E5%B1%B1%E5%BA%97)/@13411516,4290391,17z?uid=341c35de82aa8ca7e6073875&ugc_type=3&ugc_ver=1&device_ratio=2&compat=1&querytype=detailConInfo&da_src=shareurl"
              width={900}
              height={600}
              loading="lazy"
            ></iframe>
          </div>
          <p>&nbsp;</p>
        </div> */}
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Venue;
